<div class="streamline m-b-sm m-l m-t-sm" *ngIf="communicationsService.recentList.length">
  <div class="sl-item" *ngFor="let inboxItem of communicationsService.recentList">
    <div class="sl-left">
      <em class="{{inboxItem.icon}} p-a-sm"></em>
    </div>
    <div class="sl-content">
      <div class="flex-center min-h-2x">
            <span class="pointer"
                  [class.not-viewed-notification-title]="!inboxItem.read"
                  [routerLink]="['/inbox/notifications', inboxItem.id]">
              {{inboxItem.title}}
            </span>
      </div>
      <div class="m-l-sm sl-date pull-right">
        {{ inboxItem.creationDate | gpDate:{timeAgo: true} }}
      </div>
      <div class="due-date-label pull-left" *ngIf="inboxItem.dueDate">
        {{ inboxItem.dueDate | gpDate:{timeAgo: true} }}
      </div>
    </div>
  </div>
</div>
<a [routerLink]="['/inbox/notifications']"
   *ngIf="communicationsService.recentList.length"
   class="btn btn-sm text-accent p-x-md m-t-xs">
  ... {{ 'DASHBOARD.load_more' | translate }}
</a>
<div class="padding" *ngIf="!communicationsService.recentList.length">
  <gp-message text="NOTIFICATIONS.no_notifications" type="info"></gp-message>
</div>

